/**
 * Delays calling `func` until `timeout` milliseconds have passed since the last call.
 * @param {Function} func
 * @param {Number} timeout
 * @return {Function} the debounced function; its `cancel()` drops a pending call
 */
const debounce = (func, timeout = 300) => {
  let timer;
  const cancel = () => clearTimeout(timer);
  const debounced = (...args) => {
    cancel();
    timer = setTimeout(func, timeout, ...args);
  };

  debounced.cancel = cancel;

  return debounced;
};

export default debounce;
